<template>
  <div>
    <SessionDetails />
  </div>
</template>

<script>

import SessionDetails from '@/components/session/SessionDetails';

export default {
  name: 'DetailsSessiom',

  components: {
    SessionDetails,
  },
};

</script>
